import React from 'react';
import { List, Spin, Modal, Typography, Empty } from 'antd';
import ThemePreviewCard from './ThemePreviewCard';

import { 
    useGetPublicThemesQuery,
    useCopyThemeMutation,
} from '../store/user';

import { setTheme } from '../store/settings';

import { useDispatch } from 'react-redux';
import { useConfirm } from '../hooks/useConfirm';

import type { ThemeItem } from '../../types';

const { Paragraph } = Typography;

interface ThemePublicModalProps {
    open: boolean;
    onClose: () => void;
}

const ThemePublicModal: React.FC<ThemePublicModalProps> = ({ open, onClose }) => {
    const dispatch = useDispatch();
    const { confirm, confirmModal } = useConfirm();
    const [copyTheme] = useCopyThemeMutation();

    const { data: themes, isLoading, error } = useGetPublicThemesQuery(undefined, { skip: !open });

    const handleApplyTheme = async (theme: ThemeItem) => {
        const result = await confirm({
            message: `Скопировать и применить тему «${ theme.name }»?`,
        });

        if (result) {
            await copyTheme({ themeId: theme.themeId });
            dispatch(setTheme({ themeId: theme.themeId, theme: theme.theme }));
            onClose();
        }
    };

    let body: React.ReactNode;

    if (isLoading) {
        body = <div style={{ textAlign: 'center', padding: 40 }}><Spin /></div>;
    } else if (error || !themes) {
        body = <div className="app-empty">Не удалось загрузить публичные темы</div>;
    } else if (!themes.message.length) {
        body = <Empty description="Пока нет публичных тем" />;
    } else {
        body = (
            <List
                grid={{
                    gutter: 16,
                    xs: 1,
                    sm: 2,
                    md: 2,
                    lg: 3,
                    xl: 3,
                    xxl: 3,
                }}
                dataSource={themes.message}
                renderItem={(theme) => (
                    <List.Item>
                        <ThemePreviewCard
                            name={theme.name}
                            theme={theme.theme}
                            isPublic={theme.isPublic}
                            applyLabel="Скопировать и применить"
                            onApply={() => handleApplyTheme(theme)}
                        />
                    </List.Item>
                )}
            />
        );
    }

    return (
        <>
            <Modal
                title="Галерея тем"
                open={open}
                onCancel={onClose}
                footer={null}
                width={860}
                destroyOnHidden
            >
                <Paragraph type="secondary" style={{ marginTop: 0 }}>
                    Выберите тему сообщества — она скопируется в ваши настройки и сразу применится.
                </Paragraph>
                {body}
            </Modal>

            {confirmModal}
        </>
    );
};

export default ThemePublicModal;
